export interface AiSystemDeploymentDTO {
  systemName: string | null;
  systemCode: string | null;
  systemClassification: string | null;
  biases: string | null; // Sesgos
  risks: string | null; // Riesgos
  usageInstructions: string | null; // InstruccionesUso
  csvHumanSupervision: string | null; // SupervisionHumana
  inputDataQuality: string | null; // CalidadDatosEntrada
  qualityMonitoring: string | null; // MonitorizacionCalidad
  logRetention: string | null; // ConservacionLogs
  fria: string | null; // FRIA
  dpia: string | null; // DPIA
  naturalPersonInteractionCheck: boolean | null; // checkInteraccionPersonasFisicas
  contentGenerationCheck: boolean | null; // checkGeneracionContenido
  biometricsEmotionsCheck: boolean | null; // checkEmocionesBiometria
  publicInterestTextCheck: boolean | null; // checkTextoInteresPublico
  userInformation: string | null; // InformacionUsuario
  aiInfrastructure: string | null; // InfraestructuraIA
  integrationMode: string | null; // ModoIntegracion
  dataSource: string | null; // OrigenDatos
  timePeriod: string | null; // PeriodoTemporal
  dataCategory: string[] | null; // CategoriaDatos
  csvQualityAccreditation: string | null; // CsvAcreditacionCalidad
  inputDataSource: string | null; // OrigenDatosEntrada
  sourceCode: string | null; // CodigoFuente
  iso42001Check: boolean | null; // checkISO42001
  iso42001: string | null; // ISO42001
  csvISO42001: string | null; // CsvISO42001
  dataSovereigntyCheck: boolean | null; // checkSoberania
  dataSovereignty: string | null; // SoberaniaDato
  equityAndAccessCheck: boolean | null; // checkEquidadyAcceso
  equityAndAccess: string | null; // EquidadyAcceso
  updateCheck: boolean | null; // checkActualización
  aiSystemUpdate: string | null; // ActualizacionSistemaIA
  latencyCheck: boolean | null; // checkLatencia
  latencyPerformance: string | null; // LatenciaRendimiento
  scalabilityCheck: boolean | null; // checkEscalabilidad
  csvScalability: string | null; // CsvEscalabilidad
  contingencyPlanCheck: boolean | null; // checkPlanContingencia
  csvContingencyPlan: string | null; // CsvPlanContinegencia
  cybersecurityCheck: boolean | null; // checkCiberseguridad
  cybersecurity: string | null; // Ciberseguridad
  csvCybersecurity: string | null; // CsvCiberseguridad
  accessControlCheck: boolean | null; // checkControlAcceso
  accessControl: string | null; // ControlAcceso
  attackProtectionCheck: boolean | null; // checkProteccionAtaques
  attackProtection: string | null; // ProteccionAtaques
  csvAttackProtection: string | null; // CsvProteccionAtaques
  resilienceCheck: boolean | null; // checkResiliencia
  resilience: string | null; // Resiliencia
  csvResilience: string | null; // CsvResiliencia
  costBenefitAnalysisCheck: boolean | null; // checkAnalisisCosteBeneficio
  costBenefitAnalysis: string | null; // AnalisisCosteBeneficio
  csvCostBenefit: string | null; // CsvCosteBeneficio
  publicValueCheck: boolean | null; // checkValorPublico
  publicValueDescription: string | null; // DescripcionValorPublico
}

export interface AiSystemDeployment {
  systemName: string | null;
  systemCode: string | null;
  systemClassification: string | null;
  biases: string | null;
  risks: string | null;
  usageInstructions: string | null;
  humanSupervision: string | null;
  inputDataQuality: string | null;
  qualityMonitoring: string | null;
  logRetention: string | null;
  fria: string | null;
  dpia: string | null;
  naturalPersonInteraction: string | null;
  contentGeneration: string | null;
  biometricsEmotions: string | null;
  publicInterestText: string | null;
  userInformation: string | null;
  aiInfrastructure: string | null;
  integrationMode: string | null;
  dataSource: string | null;
  timePeriod: string | null;
  dataCategory: string[] | null;
  qualityAccreditation: string | null;
  inputDataSource: string | null;
  sourceCode: string | null;
  iso42001: string | null;
  iso42001Csv: string | null;
  iso42001Description: string | null;
  dataSovereignty: string | null;
  dataSovereigntyDescription: string | null;
  equityAndAccess: string | null;
  equityAndAccessDescription: string | null;
  aiSystemUpdate: string | null;
  aiSystemUpdateDescription: string | null;
  latencyPerformance: string | null;
  latencyPerformanceDescription: string | null;
  scalability: string | null;
  scalabilityCsv: string | null;
  contingencyPlan: string | null;
  contingencyPlanCsv: string | null;
  cybersecurity: string | null;
  cybersecurityCsv: string | null;
  cybersecurityDescription: string | null;
  accessControl: string | null;
  accessControlDescription: string | null;
  attackProtection: string | null;
  attackProtectionCsv: string | null;
  attackProtectionDescription: string | null;
  resilience: string | null;
  resilienceCsv: string | null;
  resilienceDescription: string | null;
  costBenefitAnalysis: string | null;
  costBenefitAnalysisCsv: string | null;
  costBenefitAnalysisDescription: string | null;
  publicValue: string | null;
  publicValueDescription: string | null;
}

export interface Step1Deployment {
  biases: string | null;
  risks: string | null;
}

export interface Step2Deployment {
  usageInstructions: string | null;
  humanSupervision: string | null;
  inputDataQuality: string | null;
  qualityMonitoring: string | null;
  logRetention: string | null;
  fria: string | null;
  dpia: string | null;
  naturalPersonInteraction: string | null;
  contentGeneration: string | null;
  biometricsEmotions: string | null;
  publicInterestText: string | null;
  userInformation: string | null;
}

export interface Step3Deployment {
  aiInfrastructure: string | null;
  integrationMode: string | null;
  dataSource: string | null;
  timePeriod: string | null;
  dataCategory: string[] | null;
  qualityAccreditation: string | null;
  inputDataSource: string | null;
  sourceCode: string | null;
}

export interface Step4Deployment {
  iso42001: string | null;
  iso42001Csv: string | null;
  iso42001Description: string | null;
  dataSovereignty: string | null;
  dataSovereigntyDescription: string | null;
  equityAndAccess: string | null;
  equityAndAccessDescription: string | null;
}

export interface Step5Deployment {
  aiSystemUpdate: string | null;
  aiSystemUpdateDescription: string | null;
  latencyPerformance: string | null;
  latencyPerformanceDescription: string | null;
  scalability: string | null;
  scalabilityCsv: string | null;
  contingencyPlan: string | null;
  contingencyPlanCsv: string | null;
  cybersecurity: string | null;
  cybersecurityCsv: string | null;
  cybersecurityDescription: string | null;
  accessControl: string | null;
  accessControlDescription: string | null;
  attackProtection: string | null;
  attackProtectionCsv: string | null;
  attackProtectionDescription: string | null;
  resilience: string | null;
  resilienceCsv: string | null;
  resilienceDescription: string | null;
}

export interface Step6Deployment {
  costBenefitAnalysis: string | null;
  costBenefitAnalysisCsv: string | null;
  costBenefitAnalysisDescription: string | null;
  publicValue: string | null;
  publicValueDescription: string | null;
}

export interface DeploymentResponse {
  statusCode: number;
  headers: string;
  body: {
    message: string;
  };
}

export function AiSystemDeploymentToDto(deployment: AiSystemDeployment): AiSystemDeploymentDTO {
  // TODO :🤔🤔🤔🤔🤔 ---> Esta funcion no es necesaria, ya que los select y multiselect tienen optionsLabel ('SI' o 'NO') y optionValue (true o false) deberi crearse un objeto option = [{labe: 'Si', value: true}, {labe: 'No', value: false}] y con esta alimentar a los select
  // Esta función existe porque el componente desy-select no admite campos boolean para el parametro value.
  const convertStringToBoolean = (value: string | null): boolean | null => {
    if (value === 'Sí') return true;
    if (value === 'No') return false;
    return null;
  };
  // TODO :🤔🤔🤔🤔🤔 ---> Añadir en el form este ternario '' ? null : value; y evitamos tambien esta otra funcion
  // esta la puedes quitar si te parece mejor
  const convertEmptyStringToNull = (value: string | null): string | null => {
    if (value === '') return null;
    return value;
  };

  return {
    systemName: deployment.systemName,
    systemCode: deployment.systemCode,
    systemClassification: deployment.systemClassification,
    biases: convertEmptyStringToNull(deployment.biases),
    risks: convertEmptyStringToNull(deployment.risks),
    usageInstructions: convertEmptyStringToNull(deployment.usageInstructions),
    csvHumanSupervision: convertEmptyStringToNull(deployment.humanSupervision),
    inputDataQuality: convertEmptyStringToNull(deployment.inputDataQuality),
    qualityMonitoring: convertEmptyStringToNull(deployment.qualityMonitoring),
    logRetention: convertEmptyStringToNull(deployment.logRetention),
    fria: convertEmptyStringToNull(deployment.fria),
    dpia: convertEmptyStringToNull(deployment.dpia),
    naturalPersonInteractionCheck: convertStringToBoolean(deployment.naturalPersonInteraction),
    contentGenerationCheck: convertStringToBoolean(deployment.contentGeneration),
    biometricsEmotionsCheck: convertStringToBoolean(deployment.biometricsEmotions),
    publicInterestTextCheck: convertStringToBoolean(deployment.publicInterestText),
    userInformation: convertEmptyStringToNull(deployment.userInformation),
    aiInfrastructure: convertEmptyStringToNull(deployment.aiInfrastructure),
    integrationMode: convertEmptyStringToNull(deployment.integrationMode),
    dataSource: convertEmptyStringToNull(deployment.dataSource),
    timePeriod: convertEmptyStringToNull(deployment.timePeriod),
    dataCategory: deployment.dataCategory,
    csvQualityAccreditation: convertEmptyStringToNull(deployment.qualityAccreditation),
    inputDataSource: convertEmptyStringToNull(deployment.inputDataSource),
    sourceCode: convertEmptyStringToNull(deployment.sourceCode),
    iso42001Check: convertStringToBoolean(deployment.iso42001),
    iso42001: convertEmptyStringToNull(deployment.iso42001Description),
    csvISO42001: convertEmptyStringToNull(deployment.iso42001Csv),
    dataSovereigntyCheck: convertStringToBoolean(deployment.dataSovereignty),
    dataSovereignty: convertEmptyStringToNull(deployment.dataSovereigntyDescription),
    equityAndAccessCheck: convertStringToBoolean(deployment.equityAndAccess),
    equityAndAccess: convertEmptyStringToNull(deployment.equityAndAccessDescription),
    updateCheck: convertStringToBoolean(deployment.aiSystemUpdate),
    aiSystemUpdate: convertEmptyStringToNull(deployment.aiSystemUpdateDescription),
    latencyCheck: convertStringToBoolean(deployment.latencyPerformance),
    latencyPerformance: convertEmptyStringToNull(deployment.latencyPerformanceDescription),
    scalabilityCheck: convertStringToBoolean(deployment.scalability),
    csvScalability: convertEmptyStringToNull(deployment.scalabilityCsv),
    contingencyPlanCheck: convertStringToBoolean(deployment.contingencyPlan),
    csvContingencyPlan: convertEmptyStringToNull(deployment.contingencyPlanCsv),
    cybersecurityCheck: convertStringToBoolean(deployment.cybersecurity),
    cybersecurity: convertEmptyStringToNull(deployment.cybersecurityDescription),
    csvCybersecurity: convertEmptyStringToNull(deployment.cybersecurityCsv),
    accessControlCheck: convertStringToBoolean(deployment.accessControl),
    accessControl: convertEmptyStringToNull(deployment.accessControlDescription),
    attackProtectionCheck: convertStringToBoolean(deployment.attackProtection),
    attackProtection: convertEmptyStringToNull(deployment.attackProtectionDescription),
    csvAttackProtection: convertEmptyStringToNull(deployment.attackProtectionCsv),
    resilienceCheck: convertStringToBoolean(deployment.resilience),
    resilience: convertEmptyStringToNull(deployment.resilienceDescription),
    csvResilience: convertEmptyStringToNull(deployment.resilienceCsv),
    costBenefitAnalysisCheck: convertStringToBoolean(deployment.costBenefitAnalysis),
    costBenefitAnalysis: convertEmptyStringToNull(deployment.costBenefitAnalysisDescription),
    csvCostBenefit: convertEmptyStringToNull(deployment.costBenefitAnalysisCsv),
    publicValueCheck: convertStringToBoolean(deployment.publicValue),
    publicValueDescription: convertEmptyStringToNull(deployment.publicValueDescription),
  };
}
